import { render, staticRenderFns } from "./POIConferenceRooms.vue?vue&type=template&id=7a485224"
import script from "./POIConferenceRooms.js?vue&type=script&lang=js&external"
export * from "./POIConferenceRooms.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports